module.exports = __webpack_public_path__ + "static/media/planet_pairs_little.5cc9ac3f.svg";